// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getSections } from '../../../libs/pagewidget';

const Section = styled(Link)`
  color: #aaa;
  font-size: 12px;
  border-bottom: dotted 1px #333;
  display: block;
  margin-bottom: 15px;
  text-decoration: none;
  padding: 5px;

  &:hover {
    color: white;
    border-bottom: dotted 1px white;
  }
`;

class SectionsList extends PureComponent {
  state = {
    sections: [],
  }
  componentDidMount() {
    if (this.props.client) {
      this.loadSections(this.props.client);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.client !== nextProps.client) {
      this.loadSections(nextProps.client);
    }
  }

  loadSections = async (client: Object) => {
    try {
      const { sections } = await getSections(client.clients_id);
      this.setState({
        sections,
      });
    } catch(ex) {
      console.error('Error al cargar secciones');
    }

  }

  props: {
    client: Object,
  }

  render() {
    return (
      <div>
        {this.state.sections.map(s => (
          <Section key={s.id} to={`/seccion/${s.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-')}-${s.id}.html`}>{s.title.toUpperCase()}</Section>
        ))}
      </div>
    );
  }
}

export default connect(state => ({
  client: state.client.info,
}))(SectionsList);



// WEBPACK FOOTER //
// ./src/components/HomeLayout/SectionsList/index.js